module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Medium.c3ac034.eot";